export const SALE_PROJECTS_ADMIN_CONSTANTS = Object.freeze({
    PROJECTS_LIST: 'SALE_PROJECTS_ADMIN__PROJECTS_LIST',
    PROJECTS_SAVE: 'SALE_PROJECTS_ADMIN__PROJECTS_SAVE',
    PROJECTS_REMOVE: 'SALE_PROJECTS_ADMIN__PROJECTS_REMOVE',
    ORDERS_LIST: 'SALE_PROJECTS_ADMIN__ORDERS_LIST',
    ORDER_STATUS: 'SALE_PROJECTS_ADMIN__ORDER_STATUS',
    ORDER_RECEIPT: 'SALE_PROJECTS_ADMIN__ORDER_RECEIPT',
});

const C = SALE_PROJECTS_ADMIN_CONSTANTS;
export const SALE_PROJECTS_ADMIN_ENDPOINTS = Object.freeze({
    [C.PROJECTS_LIST]: '/sales/admin/projects',
    [C.PROJECTS_SAVE]: '/sales/admin/projects/save',
    [C.PROJECTS_REMOVE]: '/sales/admin/projects/remove',
    [C.ORDERS_LIST]: '/sales/admin/orders',
    [C.ORDER_STATUS]: '/sales/admin/orders/status',
    [C.ORDER_RECEIPT]: '/sales/admin/orders/receipt',
});

export const SALE_PROJECTS_ADMIN_API = Object.freeze({
    LIST: C.PROJECTS_LIST,
    SAVE: C.PROJECTS_SAVE,
    REMOVE: C.PROJECTS_REMOVE,
    ORDERS: C.ORDERS_LIST,
    ORDER_STATUS: C.ORDER_STATUS,
    ORDER_RECEIPT: C.ORDER_RECEIPT,
});
